module.exports = __webpack_public_path__ + "img/footer-Rectangle.f37df565.png";